import { IGestaoLogsControleReparoFiltro } from "../../../Interfaces/Geral/GestaoLogsControleReparo/GestaoLogsControleReparoInterface";
import { ListarGestaoLogsControleReparoService } from "../../../Services/Geral/GestaoLogsControleReparo/GestaoLogsControleReparoService";
import { Controller } from "../../Controller";

export async function ListarGestaoLogsControleReparoController(ID_PAGINA: number, requestBody: IGestaoLogsControleReparoFiltro, excel?: boolean) {
    return Controller(ListarGestaoLogsControleReparoService(ID_PAGINA, requestBody, excel));
}

export async function ExportarExcelListarGestaoLogsControleReparoService(
    data: IGestaoLogsControleReparoFiltro,
) {
    return Controller(
        ListarGestaoLogsControleReparoService(
            0,
            data,
            true
        )
    );
}